import { AppState } from 'react-native';
import { store } from '../store';
import { upToDate, isNew } from './helpers';
import * as FileObjectTypes from '../constants/objectTypes';

import { getCasesArray, getCurrentEmployer } from '../selectors/entities';
import { FB_REMOVE_FOLLOWER, EMPLOYER_SETUP_DATA_UPDATED } from '../actions/actionTypes';

import * as EmployerSetupDataTypes from '../constants/employerSetupDataTypes';

import { getCaseEventById, removeCaseEventLocally } from '../screens/calendar/actions';

import {
  caseInfoChanged,
  getCaseAndAddItToRedux,
  getUserInfoForParticipant,
  removeParticipantLocally,
  removeUserFromCaseAfterServerRemovedIt,
} from '../screens/cases/actions';
import {
  getGroupMessageById,
  getTopicById,
  removeGroupMessageLocally,
} from '../screens/messaging/actions';
import { getUserInfoBasedOnProfileChange, getFollowerById } from '../screens/userProfile/actions';
import { getFullPatientForMyUser, getPatientById } from '../reducers/entities_patients';
import { getFileByTypeAndId } from '../screens/components/actions';
import {
  getEmployerById,
  getOccHealthRequirements,
  getOccHealthDepartments,
  getMedRecruiterClinicalLocations,
} from '../screens/employer/actions';
import {
  getAppointmentRequests,
  fetchCanceledAppointments,
  getAppointmentSlotAvailabilityAuthed,
} from '../screens/airforce/scheduler/slice';
import {
  getSchedulerAppointmentWindows,
  getSchedulerNotificationMessages,
} from '../screens/airforce/setup/slice';
import { getCMRRevenueCycleServices } from '../screens/airforce/cmr_revenue_cycle/slice';
import {
  fetchOutboundConsultReferrals,
  fetchInboundConsultReferrals,
} from '../screens/referrals/actions';
import { rosterStateUpdated } from '../screens/staff/actions';
import {
  scheduleChangeUpdateFor,
  regionLockableDateChanged,
} from '../screens/staffScheduling/actions';

import { fileComponentKey as cKey } from '../helpers/reducers';
import { getCaseEventByEventIdInState } from '../helpers/entities_calendar';

function entities() {
  return store.getState().entities;
}
function getState() {
  return store.getState();
}

const dispatch = store.dispatch;

let wasInBackground = false;
let appStateSubscription = null;

const DELETE = 'DELETE';
const UPDATE = 'UPDATE';
const CREATE = 'CREATE';

const CASES = 'cases';
const EVENTS = 'events';
const TOPICS = 'topics';
const PARTICIPANTS = 'participants';
const CASE_INFO = 'caseInfo';
const GROUP_MESSAGES = 'group_messages';

const USERS = 'users';
const PROFILE = 'profile';
const NOTIFICATIONS = 'notifications';
const PATIENT = 'patient';

const PATIENTS = 'patients';
const PATIENT_INFO = 'patientInfo';

const FILES = 'files';

const EMPLOYERS = 'employers';
const EMPLOYER_INFO = 'employerInfo';

const CONSULTS = 'consults';
const ROSTER_STATE = 'rosterState';

const APPTS_SCHEDULE = 'appointmentrequest_schedule';
const APPTS_SCHEDULE_WINDOWS = 'apptRequestScheduleWindows';
const SCHEDULER_NOTIFICATION_MESSAGES = 'schedulerNotificationMessages';
const APPTS_REQUESTS = 'apptRequests';
const APPTS_REQUESTS_CANCELLATIONS = 'apptRequestCancellations';
const APPTS_SCHEDULE_OVERRIDES = 'apptRequestScheduleOverrides';
const CMR_REVENUE_CYCLE_SERVICES = 'cmr-revenue-cycle-services';

const OCCHEALTH_DEPARTMENTS = 'occ-health-departments';
const OCCHEALTH_REQUIREMENTS = 'occ-health-requirements';
const MED_RECRUITER_CLINICAL_LOCATIONS = 'med-recruiter-clinical-locations';

const MED_RECRUITER_SCHEDULE = 'med-recruiter-schedule';
const MED_RECRUITER_SCHEDULE_EXPORT = 'med-recruiter-schedule-export';

import { __WEB__ } from '../constants/styles';
import { closeWS, initWS } from './websockets';

function handleAppStateChange(newAppState) {
  console.info('handleAppStateChange', newAppState);
  if (newAppState == 'background') {
    wasInBackground = true;
    closeWS();
  } else if (newAppState == 'active') {
    if (wasInBackground) {
      wasInBackground = false;
      initWS();
    }
  }
}

function _fetchFiles(objectType, objectId, updated) {
  const fileKey = cKey({ objectType, objectId });
  const needFetch = !upToDate(entities().files, fileKey, updated);
  // console.info('>>>> needFetch', needFetch, fileKey, updated)
  if (needFetch) dispatch(getFileByTypeAndId(objectType, objectId));
}

const HANDLERS = {
  [USERS]: {
    [PROFILE]: async function (userId, none, updated, operation, dynamicId, doc) {
      const currentUserId = getState().user.userId;
      const isCurrentUser = userId === currentUserId;
      const userIsInFollowers = !isNew(entities().followers, userId);

      // console.info('>>>>> user PROFILE handler', userId, none, updated, currentUserId, doc.onlySelf);

      // ignore if we are not interested in this user
      if (!isCurrentUser && !userIsInFollowers) return;

      if (isCurrentUser) {
        // console.info(
        //   '>>>>> own user PROFILE handler',
        //   userId,
        //   none,
        //   updated,
        //   currentUserId,
        //   doc.onlySelf
        // );
        const userProfile = entities().userProfile;
        if (userProfile && userProfile.updated < updated) {
          // console.info('>>>>> fetching own user info');
          dispatch(getUserInfoBasedOnProfileChange(userId));
        }
      } else if (userIsInFollowers && !doc.onlySelf) {
        const needFetch = !upToDate(entities().followers, userId, updated);
        if (needFetch) dispatch(getFollowerById(userId));
      }
    },
    [CASES]: async function (userId, caseId, updated, operation, none, doc) {
      // console.info('>>>> user cases handler', userId, caseId, updated, operation, none, doc._id);

      // ignore if its not an update on the current user
      const currentUserId = getState().user.userId;
      if (userId !== currentUserId) return;

      switch (operation) {
        case CREATE:
        case UPDATE:
          if (!upToDate(entities().cases, caseId, updated)) {
            await store.dispatch(getCaseAndAddItToRedux(caseId));
          }
          break;

        case DELETE:
          dispatch(removeUserFromCaseAfterServerRemovedIt(caseId));
      }
    },
    [NOTIFICATIONS]: async function (userId, id, updated, operation, dynamicId, doc) {
      // ignore if its not an update on the current user
      const currentUserId = getState().user.userId;
      if (userId !== currentUserId) return;

      dispatch({
        type: 'NOTIFICATIONS_BADGE_NUMBER_CHANGED',
        payload: doc.unread || 0,
      });
    },
    [PATIENT]: async function (userId, patientId, updated, operation) {
      // ignore if its not an update on the current user
      const currentUserId = getState().user.userId;
      if (userId !== currentUserId) return;

      dispatch(getFullPatientForMyUser());
    },
  },
  [CASES]: {
    [MED_RECRUITER_SCHEDULE]: async function (caseId, scheduleId, updated, operation) {
      // console.info('>>>> CASES MED_RECRUITER_SCHEDULE handler', caseId, scheduleId, updated, operation);

      dispatch(scheduleChangeUpdateFor(caseId));
    },
    [EVENTS]: async function (caseId, eventId, updated, operation) {
      // console.info('>>>> CASES EVENTS handler', caseId, eventId, updated, operation);

      switch (operation) {
        case CREATE:
        case UPDATE:
          const needFetch = !upToDate(entities().calendar[caseId], eventId, updated);
          if (needFetch) await store.dispatch(getCaseEventById(eventId, caseId));

          break;

        case DELETE:
          if (entities().calendar?.[caseId]?.[eventId]) {
            dispatch(removeCaseEventLocally(eventId));
            // if we have an employer then we have deleted cancelled an appointment so
            // we need to refetch the slot availability
            // we dont do this for created events because there will be also an appointment request
            // event when the appointment request status has changed which already triggers
            // the same fetch
            const currentEmployer = getCurrentEmployer(getState());
            if (currentEmployer) {
              dispatch(
                getAppointmentSlotAvailabilityAuthed({ employerId: currentEmployer.employerId })
              );
            }
          }
      }
    },
    [TOPICS]: async function (caseId, topicId, updated, operation) {
      // console.info('>>>> TOPICS handler', caseId, topicId, updated, operation);

      switch (operation) {
        case CREATE:
        case UPDATE:
          const needFetch = !upToDate(entities().topics, topicId, updated);
          if (needFetch) dispatch(getTopicById(topicId, { caseId }));
          break;

        case DELETE:
        // dispatch(removeCaseEventLocally(eventId));
      }
    },
    [GROUP_MESSAGES]: async function (caseId, messageId, updated, operation, topicId) {
      // console.info('>>>> GROUP_MESSAGES handler', caseId, topicId, updated, operation, messageId);

      switch (operation) {
        case CREATE:
        case UPDATE:
          const reduxTopic = entities().topics[topicId];
          if (!reduxTopic) return;
          const needFetch = !upToDate(reduxTopic.messages, messageId, updated);
          if (needFetch) await dispatch(getGroupMessageById(topicId, messageId, caseId, null));

          break;

        case DELETE:
          dispatch(removeGroupMessageLocally(topicId, messageId));
      }
    },
    [PARTICIPANTS]: async function (caseId, userId, updated, operation) {
      // console.info('>>>> PARTICIPANTS handler', caseId, userId, updated, operation);

      switch (operation) {
        case CREATE:
        case UPDATE:
          const needFetch = !upToDate(entities().cases[caseId].participants, userId, updated);
          if (needFetch) {
            await store.dispatch(getUserInfoForParticipant(userId, caseId));
            await store.dispatch(getFollowerById(userId, caseId, null));
          }

          break;

        case DELETE:
          dispatch(removeParticipantLocally(userId, caseId));
      }
    },
    [CASE_INFO]: async function (caseId, none, updated, operation) {
      // console.info('>>>> CASE_INFO handler', caseId, none, updated, operation);

      if (!upToDate(entities().cases, caseId, updated)) {
        dispatch(caseInfoChanged(caseId));
      }
    },
  },
  [FILES]: {
    [FileObjectTypes.EVENTS]: async function (none, objectId, updated, operation) {
      // console.info('>>>>> processing FILES EVENTS', none, objectId, updated, operation);

      if (!getCaseEventByEventIdInState(getState(), objectId)) return;

      _fetchFiles(FileObjectTypes.EVENTS, objectId, updated);
    },
    [FileObjectTypes.CASE_AVATAR]: async function (none, objectId, updated, operation) {
      // console.info('>>>>> processing FILES CASE_AVATAR', none, objectId);

      if (!entities().cases[objectId]) return;

      _fetchFiles(FileObjectTypes.CASE_AVATAR, objectId, updated);
    },
  },
  [PATIENTS]: {
    [PATIENT_INFO]: async function (patientId, none, updated, operation) {
      // console.info('>>>> PATIENT_INFO handler', patientId, none, updated, operation);

      if (!upToDate(entities().patients, patientId, updated)) {
        dispatch(getPatientById({ patientId }));
      }
    },
  },
  [EMPLOYERS]: {
    [MED_RECRUITER_SCHEDULE_EXPORT]: async function (employerId, region, updated) {
      // console.info('>>>> MED_RECRUITER_SCHEDULE_EXPORT handler', employerId, region, updated);
      if (!entities().employers[employerId]) return;
      dispatch(regionLockableDateChanged(employerId, region, updated));
    },
    [APPTS_SCHEDULE]: async function (employerId) {
      // console.info('>>>> EmployerSetupDataTypes.GROUPS handler', employerId);
      if (!entities().employers[employerId]) return;
      dispatch(getAppointmentSlotAvailabilityAuthed({ employerId }));
    },
    [APPTS_SCHEDULE_WINDOWS]: async function (employerId) {
      // console.info('>>>> Employer.APPTS_SCHEDULE_WINDOWS handler', employerId);
      if (!entities().employers[employerId]) return;
      dispatch(getSchedulerAppointmentWindows({ employerId }));
    },
    [SCHEDULER_NOTIFICATION_MESSAGES]: async function (employerId) {
      dispatch(getSchedulerNotificationMessages({ employerId }));
    },
    [APPTS_SCHEDULE_OVERRIDES]: async function (employerId) {
      // console.info('>>>> EmployerSetupDataTypes.GROUPS handler', employerId);
      if (!entities().employers[employerId]) return;
      dispatch(getAppointmentSlotAvailabilityAuthed({ employerId }));
    },
    [APPTS_REQUESTS]: async function (employerId) {
      // console.info('>>>> EmployerSetupDataTypes.GROUPS handler', employerId);
      if (!entities().employers[employerId]) return;
      dispatch(getAppointmentRequests({ employerId }));
      dispatch(getAppointmentSlotAvailabilityAuthed({ employerId }));
    },
    [APPTS_REQUESTS_CANCELLATIONS]: async function (employerId) {
      // console.info('>>>> Employer.APPTS_REQUESTS_CANCELLATIONS handler', employerId);
      if (!entities().employers[employerId]) return;
      dispatch(fetchCanceledAppointments({ employerId }));
    },
    [CMR_REVENUE_CYCLE_SERVICES]: async function (employerId) {
      const currentEmployer = getCurrentEmployer(getState());
      if (currentEmployer?.employerId !== employerId) return;
      dispatch(getCMRRevenueCycleServices({ employerId }));
    },
    [EmployerSetupDataTypes.GROUPS]: async function (employerId) {
      // console.info('>>>> EmployerSetupDataTypes.GROUPS handler', employerId);
      dispatch({
        type: EMPLOYER_SETUP_DATA_UPDATED,
        payload: { itemsPath: EmployerSetupDataTypes.GROUPS },
      });
    },
    [EmployerSetupDataTypes.MEDICAL_SERVICES]: async function (employerId) {
      // console.info('>>>> EmployerSetupDataTypes.MEDICAL_SERVICES handler', employerId);
      dispatch({
        type: EMPLOYER_SETUP_DATA_UPDATED,
        payload: { itemsPath: EmployerSetupDataTypes.MEDICAL_SERVICES },
      });
    },
    [EmployerSetupDataTypes.CLINICAL_LOCATION_MEDICAL_SERVICE]: async function (employerId) {
      // console.info('>>>> EmployerSetupDataTypes.CLINICAL_LOCATION_MEDICAL_SERVICE handler', employerId);
      dispatch({
        type: EMPLOYER_SETUP_DATA_UPDATED,
        payload: { itemsPath: EmployerSetupDataTypes.CLINICAL_LOCATION_MEDICAL_SERVICE },
      });
    },
    [EmployerSetupDataTypes.CLINICAL_LOCATIONS]: async function (employerId) {
      // console.info('>>>> EmployerSetupDataTypes.CLINICAL_LOCATIONS handler', employerId);
      dispatch({
        type: EMPLOYER_SETUP_DATA_UPDATED,
        payload: { itemsPath: EmployerSetupDataTypes.CLINICAL_LOCATIONS },
      });
    },
    [EMPLOYER_INFO]: async function (employerId, none, updated, operation) {
      // console.info('>>>> EMPLOYER_INFO handler', employerId, none, updated, operation);

      const needFetch = !upToDate(entities().employers, employerId, updated);
      if (needFetch) dispatch(getEmployerById(employerId));
    },
    [ROSTER_STATE]: async function (employerId, none, updated, operation) {
      // console.info('>>>> ROSTER_STATE handler', employerId, none, updated, operation);

      dispatch(rosterStateUpdated(updated));
    },
    [PARTICIPANTS]: async function (employerId, userId, updated, operation) {
      // console.info('>>>> EMPLOYER PARTICIPANTS handler', employerId, userId, updated, operation);

      const cases = getCasesArray(getState());
      switch (operation) {
        case CREATE:
        case UPDATE:
          await Promise.all(
            cases
              .filter((c) => c.employerId === employerId)
              .map((c) => {
                return dispatch(getUserInfoForParticipant(userId, c.caseId));
              })
          );
          dispatch(getFollowerById(userId, null, employerId));
          break;

        case DELETE:
          await Promise.all(
            cases
              .filter((c) => c.employerId === employerId)
              .map((c) => {
                return dispatch(removeParticipantLocally(userId, c.caseId));
              })
          );
          dispatch({ type: FB_REMOVE_FOLLOWER, payload: { userId } });
      }
    },
    [TOPICS]: async function (employerId, topicId, updated, operation, dynamic, doc) {
      // console.info('>>>>>> employer topic message', employerId, topicId, doc);
      if (doc.members?.length) {
        if (!doc.members.find((m) => m.userId === getState().user?.userId)) return;
      }
      switch (operation) {
        case CREATE:
        case UPDATE:
          const needFetch = !upToDate(entities().topics, topicId, updated);
          if (needFetch) dispatch(getTopicById(topicId, { employerId }));
          break;

        case DELETE:
        // dispatch(removeCaseEventLocally(eventId));
      }
    },
    [GROUP_MESSAGES]: async function (employerId, messageId, updated, operation, topicId) {
      // console.info(
      //   '>>>> GROUP_MESSAGES handler',
      //   employerId,
      //   topicId,
      //   updated,
      //   operation,
      //   messageId
      // );

      switch (operation) {
        case CREATE:
        case UPDATE:
          const reduxTopic = entities().topics[topicId];
          if (!reduxTopic) return;
          const needFetch = !upToDate(reduxTopic.messages, messageId, updated);
          if (needFetch) await dispatch(getGroupMessageById(topicId, messageId, null, employerId));

          break;

        case DELETE:
          dispatch(removeGroupMessageLocally(topicId, messageId));
      }
    },
    [CONSULTS]: async function (employerId, collection, updated, operation, none, doc) {
      const currentUserId = getState().user.userId;

      if (collection === 'inbound') {
        if (!(doc?.recipientIds || []).includes(currentUserId)) return;
        dispatch(fetchInboundConsultReferrals());
      } else if (collection === 'outbound') {
        if (doc?.authorId !== currentUserId) return;
        dispatch(fetchOutboundConsultReferrals());
      }
    },
    [OCCHEALTH_DEPARTMENTS]: async function (employerId) {
      dispatch(getOccHealthDepartments(employerId));
    },
    [OCCHEALTH_REQUIREMENTS]: async function (employerId) {
      dispatch(getOccHealthRequirements(employerId));
    },
    [MED_RECRUITER_CLINICAL_LOCATIONS]: async function (employerId) {
      dispatch(getMedRecruiterClinicalLocations(employerId));
    },
  },
};

export async function handleDocChange(doc) {
  // why doc sometimes be the same as doc._id?
  const docId = doc._id || doc;
  // docId = 'users/20/cases/undefined'
  // if (!docId) return;
  // console.info('>> docId', docId)

  const deleted = !!doc._deleted || !!doc.isDelete;
  const created = !!doc.isCreate;
  const updated = doc.updated || new Date();

  const operation = deleted ? DELETE : created ? CREATE : UPDATE;

  //console.info('>>> handleDocChange', doc, docId, updated, operation);

  const pathParts = docId.split('/');

  // if its not in a format we understand return
  if (pathParts.length < 3) return;

  const collection = pathParts[0];
  let collectionId = parseInt(pathParts[1]);
  const subCollectionParts = pathParts[2].split('@');
  let subCollection = subCollectionParts[0];
  let id = parseInt(pathParts[3]);
  const dynamicId = parseInt(subCollectionParts[1]);

  let skipUpdate = false;

  if (!collectionId || isNaN(collectionId)) {
    if (collection !== FILES) {
      console.error(`received bad live update: ${docId}`);
    }
  }

  switch (collection) {
    case EMPLOYERS:
      if (isNew(entities().employers, collectionId)) skipUpdate = true;
      if (subCollection === CONSULTS) id = pathParts[3];
      break;
    case CASES:
      // console.info('>>>>> CASES collection');
      // ignore if user is not a participant on this case
      if (!entities().cases[collectionId]) skipUpdate = true;

      if (
        subCollection === EVENTS &&
        skipUpdate &&
        doc.caseEmployerId &&
        entities().employers[doc.caseEmployerId] &&
        !entities().employers[doc.caseEmployerId].external
      ) {
        skipUpdate = false;
      }
      break;
    case PATIENTS:
      // console.info('>>>>> PATIENT collection', collection);
      // ignore if we dont know about this patient
      if (isNew(entities().patients, collectionId)) skipUpdate = true;
      break;
    case FILES:
      // console.info('>>>>> FILES collection');
      subCollection = pathParts[1];
      id = parseInt(pathParts[2]);
      collectionId = null;
      break;
  }

  if (skipUpdate) return;

  // console.info(
  //   '>>>> processing collection',
  //   collection,
  //   subCollection,
  //   collectionId,
  //   id,
  //   updated,
  //   operation,
  //   dynamicId
  // );

  HANDLERS[collection] &&
    HANDLERS[collection][subCollection] &&
    HANDLERS[collection][subCollection](collectionId, id, updated, operation, dynamicId, doc);
}

async function handleReduxChange() {
  if (getState().application.coldStartFinished) {
    initWS(handleDocChange);

    if (!__WEB__ && !appStateSubscription) {
      appStateSubscription = AppState.addEventListener('change', handleAppStateChange);
    }
  }

  if (!getState().user.userId) {
    if (!__WEB__ && appStateSubscription) {
      appStateSubscription.remove();
      appStateSubscription = null;
      wasInBackground = null;
    }
    closeWS();
  }
}

export async function init() {
  store.subscribe(handleReduxChange);
}
